"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    menuSplitGroupClassNames: function() {
        return menuSplitGroupClassNames;
    },
    useMenuSplitGroupStyles_unstable: function() {
        return useMenuSplitGroupStyles_unstable;
    }
});
const _react = require("@griffel/react");
const menuSplitGroupClassNames = {
    root: 'fui-MenuSplitGroup'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        ni5quz: "flhoj8d",
        Irip7g: [
            "fj7wzln",
            "fagfnhl"
        ],
        pgpdld: [
            "fghv8el",
            "f1r95qti"
        ],
        nep80a: [
            "fog3xzc",
            "f146oqes"
        ],
        Btx6110: "f5673lx",
        B1zw9a1: "f23uflp",
        B857g0j: "f1sqsvnd",
        Bx4l464: "f1k81338"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".flhoj8d>.fui-MenuItem:nth-of-type(1){flex-grow:1;}",
        ".fj7wzln>.fui-MenuItem:nth-of-type(2){border-top-left-radius:0;}",
        ".fagfnhl>.fui-MenuItem:nth-of-type(2){border-top-right-radius:0;}",
        ".fghv8el>.fui-MenuItem:nth-of-type(2){border-bottom-left-radius:0;}",
        ".f1r95qti>.fui-MenuItem:nth-of-type(2){border-bottom-right-radius:0;}",
        ".fog3xzc>.fui-MenuItem:nth-of-type(2){padding-left:0;}",
        ".f146oqes>.fui-MenuItem:nth-of-type(2){padding-right:0;}",
        ".f5673lx>.fui-MenuItem:nth-of-type(2)::before{content:\"\";}",
        ".f23uflp>.fui-MenuItem:nth-of-type(2)::before{width:var(--strokeWidthThin);}",
        ".f1sqsvnd>.fui-MenuItem:nth-of-type(2)::before{height:24px;}",
        ".f1k81338>.fui-MenuItem:nth-of-type(2)::before{background-color:var(--colorNeutralStroke1);}"
    ]
});
const useMenuSplitGroupStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(menuSplitGroupClassNames.root, styles.root, state.root.className);
    return state;
}; //# sourceMappingURL=useMenuSplitGroupStyles.styles.js.map
